export default "__VITE_ASSET__BkCFSeHW__"